import React from 'react';
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
import {capitalizeFirstLetter} from '../../utils/letters'

function HomeFooter({ footerData, isLoading }) {
    const config = footerData && footerData.length > 0 ? footerData[0] : null;

    return (
        <footer className="font-n">
            <div className="select-info">
                <div className="block-first">
                    <div className="footer-header">
                        <img src="/img/somnus.webp" alt="Instituto de Capacitación" className="footer-logo" />
                        <div className="footer-title">
                            <span className="logo-somnus-footer">Somnus</span>
                            <p className="sub-txt-f">Institución de Capacitación</p>
                        </div>
                    </div>
                    
                    <div className="block-red">
                        {!isLoading && config ? (
                            <>
                                {config.social_instagram && (
                                    <a href={config.social_instagram} target="_blank" rel="noreferrer">
                                        <i className="fa-brands fa-instagram" style={{fontSize: '24px', marginRight: '10px'}}></i>
                                    </a>
                                )}
                                {config.social_facebook && (
                                    <a href={config.social_facebook} target="_blank" rel="noreferrer">
                                        <i className="fa-brands fa-facebook" style={{fontSize: '24px', marginRight: '10px'}}></i>
                                    </a>
                                )}
                                {config.social_linkedin && (
                                    <a href={config.social_linkedin} target="_blank" rel="noreferrer">
                                        <i className="fa-brands fa-linkedin" style={{fontSize: '24px'}}></i>
                                    </a>
                                )}
                            </>
                        ) : (
                            <span className="loading-dots">Cargando redes...</span>
                        )}
                    </div>
                </div>

                <div className="block-second">
                    <div className="footer-links">
                        <span className="footer-subtitle">Navegación</span>
                        <ul>
                            <li><HashLink smooth to="/#">Inicio</HashLink></li>
                            <li><HashLink smooth to="/nosotros">Nosotros</HashLink></li>
                            <li><Link to="/cursos">Cursos</Link></li>
                            <li><Link to="/validar-certificados">Validar certificados</Link></li>
                            <li><HashLink smooth to="/#asesorias">Asesorias</HashLink></li>
                            <li><Link to="/noticias">Noticias</Link></li>
                        </ul>
                    </div>
                    
                    <div className="footer-links">
                        <span className="footer-subtitle">Legal</span>
                        <ul>
                            <li><Link to="/politicas">Políticas</Link></li>
                        </ul>
                    </div>

                    <div className="footer-contact">
                        <span className="footer-subtitle">Contacto</span>
                        {isLoading ? (
                            <div className="loader-container">
                                <p className="txt-loading">Cargando datos...</p>
                            </div>
                        ) : config ? (
                            <>
                                <div className="info-tel">
                                    <p>Tel:</p>
                                    <span>+56 {config.contacto_telefono || "No disponible"}</span>
                                </div>
                                <div className="info-email">
                                    <p>Emails:</p>
                                    <div className="div-email">
                                        <span>{config.contacto_email || "No disponible"}</span>
                                    </div>
                                </div>
                                <div className="info-adress">
                                    <p>Dirección:</p>
                                    <span>{capitalizeFirstLetter(config.contacto_direccion || "No disponible")}</span>
                                </div>
                            </>
                        ) : (
                            <p>Información no disponible</p>
                        )}
                    </div>
                </div>
            </div>
            
            <div className="copyright-section">
                <hr className="footer-divider-line" />
                <p className="txt-copyright">
                    2026 &copy; Somnus. Todos los derechos reservados.
                </p>
            </div>
        </footer>
    );
}

export default HomeFooter;
